import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { useDataGroups } from 'common/contexts/react/data-group-context';
import { useCohorts } from 'common/contexts/react/cohorts-context';
import { transformToQuerySegmentEntries } from 'common/query-builder/query-builder/util';
import { segmentationToPropertySelection } from 'common/query-builder/query-block/segment-menu/util';
import { getSelectedLabel } from 'common/query-builder/query-block/properties-menu/util';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { Segmentation } from 'common/types/reports/query';
import { getFirstSegment, Segment } from 'common/query-builder/query-block/segment-menu/types';
import { BreakdownDropMenu } from './breakdown-menu';
import { BreakdownEvents, track } from './tracking';
export function BreakdownPlaceholder(props: {
  onAdd: (breakdown: Segmentation) => void;
  onClose: () => void;
  projectId: number;
  workspaceId: number;
  userId: number;
  trackName: string;
  onTrack: (ev: CustomEvent) => void;
}) {
  const {
    t,
    print
  } = useTranslation();
  const dataGroups = useDataGroups();
  const cohortsStore = useCohorts();
  const onAdd = (breakdown: Segment) => {
    const entry = transformToQuerySegmentEntries([breakdown])[0];
    const selected = segmentationToPropertySelection(entry.event);
    const propertyName = getSelectedLabel({
      selected,
      dataGroups: [...Object.values(dataGroups.value)],
      cohortsStore,
      expandListProperties: false
    });
    track(BreakdownEvents.AddBreakdown, {
      propertyName: print(propertyName)
    });
    props.onAdd(getFirstSegment(breakdown));
  };
  return <div data-sentry-component="BreakdownPlaceholder" data-sentry-source-file="breakdown-placeholder.tsx">
      <ButtonReact theme={ButtonTheme.Tertiary} pressed data-sentry-element="ButtonReact" data-sentry-source-file="breakdown-placeholder.tsx">
        {t("query-builder.new-breakdown")}
      </ButtonReact>
      <BreakdownDropMenu onCommit={onAdd} onClose={props.onClose} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} data-sentry-element="BreakdownDropMenu" data-sentry-source-file="breakdown-placeholder.tsx" />
    </div>;
}